// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2daVU","title":"FrontImage_title__2pdjs"};